import PropTypes from 'prop-types';
import React from 'react';
import SurveyIcon from '../SurveyIcon';
import { t } from '../../../utils/translate';

const Flash = ({ messages }) => {
  return (
    <div>
      {Object.keys(messages).map(
        type =>
          typeof messages[type] === 'string' ? (
            <FlashMessage type={type} msg={messages[type]} />
          ) : null
      )}
    </div>
  );
};

Flash.propTypes = {
  messages: PropTypes.object,
};

const FlashMessage = ({ type, msg }) => (
  <div className={`box box-flash box-flash-${type}`}>
    <SurveyIcon icon={type === 'error' ? 'warning' : 'info'} /> {t(msg)}
  </div>
);

FlashMessage.propTypes = {
  msg: PropTypes.string,
  type: PropTypes.string,
};

export default Flash;
